import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import { LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA } from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery, {
	type onboardingStateGetOnboardingStateQuery$data,
	type onboardingStateGetOnboardingStateQuery$variables,
} from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';

export const preloadLandUsersInEditorWithRevampedBpqa = () => {
	return query<
		onboardingStateGetOnboardingStateQuery$data,
		onboardingStateGetOnboardingStateQuery$variables
	>({
		query: onboardingStateGetOnboardingStateQuery,
		variables: {
			key: [...Object.values(LAND_USERS_IN_EDITOR_WITH_REVAMPED_BPQA)],
		},
	});
};
